@if (state() && !blocking()) {
  <div class="offlineBanner" [class.backOnline]="state() === 'back'" role="status">
    {{ (state() === 'back' ? 'OFFLINE.BACK_ONLINE' : 'OFFLINE.BANNER') | translate }}
  </div>
}
